import { Row, Col } from "../../components/RowCol";
import Carousel from "../../components/Carousel";
import whiteCheckIcon from "../../assets/img/success-whitecheck-mark.svg";
import blueCheckIcon from "../../assets/img/success-blue-check-mark.svg";
import rightArrow from "../../assets/img/right-arrow-white.svg";
import styled from "styled-components";

import "../Layout/Layout.scss";

import SearchLayout from "../../components/Layout/SearchLayout";
import { Link } from "react-router-dom";

function MainCarousel({ type, setSearchText }) {


  return (
    <CarouselWrapper>
      <div
        style={{
          background: "url(/img/Carousel-1.png)",
          width: "100%",
          height: "300px",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          padding: "1% 2% 5% 2%",
        }}
      >
        <Row>
          <Col area="span 12">
            <Row>
              <Col area="span 12">
                <Heading style={{ marginBottom: "-20px", color: "#76787a" }}>
                  {type === "doctor"
                    ? "Help whoever is worried about health"
                    : "Worried about health?"}
                </Heading>
                <SubHeading
                  style={{
                    marginTop: "2%",
                    marginBottom: "4%",
                    lineHeight: 1,
                    color: "#76787a",
                  }}
                >
                  We are always here to care about health, We provide best
                  medical service
                </SubHeading>
                <SubHeading></SubHeading>
              </Col>
            </Row>
            <Row>
              <Col area="span 2"> </Col>
              <Col area="span 8">
                <SearchLayout setSearchText={setSearchText} />
              </Col>
              <Col area="span 2"> </Col>
            </Row>
            <Row>
              <Col area="span 2"> </Col>
              <Col area="span 8">
                <div style={{ display: "flex", marginTop: "1%", marginLeft: "4%" }}>
                  <Button type="border" className="button-in-one-line">
                    <img src={blueCheckIcon} alt="blue check" />
                    <b>
                      Book Lab Tests
                    </b>
                  </Button>
                  <Button type="primary" className="button-in-one-line">
                    <img src={whiteCheckIcon} alt="white check" />
                    {type === "doctor"
                      ?
                      <Link
                        to="/doctor/appointments"
                        title="View your Appointments"
                      >
                        <b>
                          View Appointments
                        </b>
                      </Link>
                      :
                      <Link
                        to="/patient/appointments"
                        title="View your Appointments"
                      >
                        <b>
                          View/ Book Appointments
                        </b>
                      </Link>
                    }

                  </Button>
                  <Button type="border" className="button-in-one-line">
                    <img src={blueCheckIcon} alt="blue check" />

                    {type === "doctor"
                      ?
                      <a
                        href="https://hlthtek.com/NDHM_FinalHTML/"
                        title="Create Health ID, Other Services"
                        target="_blank"
                        style={{ color: "black" }}
                      >
                        <b>
                          Create Health ID, Other Services
                        </b>
                      </a>
                      :
                      <b>
                        View Health Records
                      </b>
                    }
                  </Button>
                </div>
              </Col>
              <Col area="span 2"> </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </CarouselWrapper>
  );
}

const Heading = styled.h1`
  margin-top: 0;
  font-weight: bold;
  font-size: 2.5rem;
`;

const SubHeading = styled.h5`
  font-weight: 600;
  line-height: 1.5;
`;

const RelativeDiv = styled.div`
  & > p {
    width: "350px";
  }

  & > button {
    padding: 1rem 2rem;
    font-weight: bold;
    background: #01d6c033 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 2px solid #01d6c0;
    border-radius: 30px;
  }
`;
const Button = styled.button`
  display: flex;
  align-items: center;
  padding: 0.5rem 2rem;
  margin-top: ${(props) => (props.type === "primary" ? "0" : "0")};
  margin-bottom: 1rem;
  margin-right: 1rem;
  background: ${(props) =>
    props.type === "primary" ? "#0D233F" : "transparent"};
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #0d233f;
  border-radius: 20px;
  color: ${(props) => (props.type !== "primary" ? "#0D233F" : "white")};
  & > img {
    margin-right: 1rem;
  }
`;

const CarouselWrapper = styled.div`
  margin: 0 auto;
  overflow: hidden;
  .slideshowSlider {
    white-space: nowrap;
    transition: ease 1000ms;
  }

  .slide {
    display: inline-block;
    width: 100%;
    border-radius: 40px;
  }

  /* Buttons */

  .slideshowDots {
    text-align: center;
  }
  .slideshowDot {
    display: inline-block;
    height: 5px;
    border-radius: 3px;
    width: 30px;
    cursor: pointer;
    margin: 15px 7px 0px;
    background-color: #a4b9ca;
  }
  .slideshowDot.active {
    background-color: #1c507a;
  }
`;
export default MainCarousel;
